<div class="not-found-top">
    <img
        src="../assets/images/logo.png"
        class="not-found-logo"
        alt="CLARK logo" />
    <div *ngIf="statusCode">
        <strong
            ><h1
                class="huge"
                tabindex="0"
                attr.aria-label="Error status: {{ statusCode }}">
                {{ statusCode }}
            </h1></strong
        >
        <div tabindex="0" class="message">
            This Learning Object is currently under review.
        </div>
        <div *ngIf="!auth.user; else unauthorized">
            <div tabindex="0" class="message">
                Try logging in to see if you have access.
            </div>
            <br />
            <div class="btn-group center">
                <a
                    class="message"
                    [routerLink]="['/auth/login']"
                    [queryParams]="{ redirectUrl: redirectUrl }"
                    aria-label="Login"
                    >Login</a
                >
            </div>
        </div>
        <ng-template #unauthorized>
            <div tabindex="0" class="message">
                You do not have access to this Learning Object.
            </div>
        </ng-template>
        <a
            routerLink=""
            class="message"
            aria-label="Clickable back to homepage link"
            >Back to Home</a
        >
    </div>
</div>
